import QRious from 'qrious';
import { useEffect, useState } from 'react';
export const useQrious = (options) => {
    const [qrious] = useState(() => new QRious(options));
    const [dataUrl, setDataUrl] = useState(() => qrious.toDataURL(options.mime));
    useEffect(() => {
        qrious.set(options);
        setDataUrl(qrious.toDataURL(options.mime));
    }, [options, qrious]);
    return [dataUrl, qrious];
};
//# sourceMappingURL=use-qrious.js.map